import React, { useState } from 'react';
import InforClient from './InforClient';
import FlipCards from './Flipcards';
import InforAllianceImage from '../../../../Assets/InforPage/LN into image.png'

import ContactForm from './Contact';
import ServiceCards from './Services';
import Faq from './Faq'
import InforServices from './InforServices';
import PhotoCollage from './PhotoCollab';

import WhatsAppButton from './Whatsapp';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';

import TitleUpdater from '../../../../utils/TitleUpdater';


const Infor = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    companyName: '',
    email: '',
    phoneNumber: '',
    message: ''
  });

  // services images 
  const services = [
    { id: 1, src: "https://img.freepik.com/free-photo/business-people-shaking-hands-together_53876-13391.jpg?semt=ais_hybrid" },
    { id: 2, src: "https://img.freepik.com/free-photo/business-concept-with-team-close-up_23-2149151159.jpg?semt=ais_hybrid" },
   { id: 3, src: "https://img.freepik.com/free-photo/business-people-shaking-hands-together_53876-13391.jpg?semt=ais_hybrid" },
    { id: 4, src: "https://img.freepik.com/free-photo/business-concept-with-team-close-up_23-2149151159.jpg?semt=ais_hybrid" },
  ]

  // Client logos array
  const clientLogos = [
    { id: 1, src: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/CMR.png?updatedAt=1735885002372", alt: "Client 1" },
    { id: 2, src: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/PT-GS-Battery.png?updatedAt=1737435858969", alt: "Client 2" },
    { id: 3, src: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/Sanoh.png?updatedAt=1735885002227", alt: "Client 3" },
    { id: 4, src: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/LT.png?updatedAt=1735885002145", alt: "Client 4" },
    { id: 5, src: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/Savio.png?updatedAt=1735885002140", alt: "Client 5" },
    { id: 6, src: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/Saden.png?updatedAt=1735885001834", alt: "Client 6" },
    { id: 7, src: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/Chaiyaboon.png?updatedAt=1735885001776", alt: "Client 7" },
    { id: 8, src: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/AvalGulf.png?updatedAt=1735885001734", alt: "Client 8" },
  ];

 

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Handle form submission here
    try {
      toast.info("Submitting Your Query..."); 
      const response = await axios.post("https://api.kapiltech.com/api/infor/InforContactChatBot", formData); 
      if (response.data.success) {
        toast.success("We'll connect you with our Support Team."); 
        setFormData({ 
          name: '',
          companyName: '',
          email: '',
          phoneNumber: '',
          message: ''
        });
      }
    } catch (error) {
      console.error("Error in form submission:", error);
      toast.error("There was an error submitting the Enquiry."); 
    }
    setIsContactOpen(false);
  };


    const structuredData = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Kapil Tech Infor Services",
    "description": "Grow your Business Operations with Kapil Tech Infor Consulting Services, Enhance Productivity with Our Expert Infor Managed Services and CloudSuite Solutions.",
    "offers": {
      "@type": "Offer",
      "serviceType": ["Infor Implementation", "ERP Consulting", "Digital Transformation,Enterprise Resource Planning, Human Capital Management, Customer Relationship Management, Industry-Specific Applications, Cloud-Based Solutions, Warehouse Management, Manufacturing Executive System, Workforce Management, Infor Consulting Services"]
    }
  };

  return (
    <div className="relative">
        <TitleUpdater title="Infor Consulting Services, LN, M3 & Syteline | Kapil Tech"   />
   {/* SEO OPTIMIZATION */}

    <Helmet>
        {/* Primary Meta Tags */}
        <title>Infor Consulting Services, LN, M3 & Syteline | Kapil Tech</title>
        <meta name="title" content="Infor Consulting Services, LN, M3 & Syteline | Kapil Tech" />
        <meta name="description" content="Grow your Business Operations with Kapil Tech Infor Consulting Services, Enhance Productivity with Our Expert Infor Managed Services and CloudSuite Solutions." />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Kapil Tech Infor Services - Leading Infor Alliance Partner" />
        <meta property="og:description" content="Expert Infor consulting services delivering digital transformation through ERP implementation, integration, and support solutions." />
        <meta property="og:image" content="https://ik.imagekit.io/kqumni8l2/Infor%20Services.jpg?updatedAt=1739434285408" />
        
        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content="Kapil Tech Infor Services - Enterprise ERP Solutions" />
        <meta property="twitter:description" content="Comprehensive Infor consulting services for businesses seeking digital transformation through expert ERP implementation." />
        <meta property="twitter:image" content="https://ik.imagekit.io/kqumni8l2/Infor%20Services.jpg?updatedAt=1739434285408" />
        
        {/* Additional SEO Meta Tags */}
        <meta name="keywords" content="Infor ERP, Infor CloudSuite, Infor Cloud ERP, Infor Mongoose, Infor ION, Infor HCM, Infor Supply Chain Management, Infor EAM (Enterprise Asset Management), Infor CRM, Infor Lawson, Infor Birst (Business Intelligence), Infor Industry Solutions, Infor Healthcare Solutions, Infor Manufacturing Software, Infor Financial Management, Infor Workforce Management, Infor Warehouse Management, Infor Syteline, Infor Global HR, Human Resources, Workforce Scheduling, SAP Staffing, Sailotech, Employee WFM Software, Enterprise WFM Software, Nurse Staffing, Driving work agility in healthcare service, Infor Software Market, Information Technology Staffing, Talent Software Services, Infor managed services, Infor consulting services, Infor federation services, Infor professional services, Infor localization services platform, Infor financial services, Infor data services, Infor m3 web services, Infor web services, Infor ln Erp, Infor m3 Erp, Infor visual erp, Infor syteline erp, Infor lawson erp, Infor erp jobs, Infor Accounting Software, Infor LN Software, Infor ERP System, Infor M3, Infor SCM, Infor ERP Software, Infor Enterprise Resource Planning ERP, Infor Login, Infor LX, SyteLine MAPICS ERP, Infor ERP Logo, Infor Hyderabad, Infor Consulting Services in Hyderabad, ERP Portal, Infor Consulting Services in Indonesia, Infor Consulting Services in Dubai, Infor Consulting Services in United States, Infor Consulting Services in Jakarta, Infor Consulting Services in America, Infor Consulting Services in Middle East, Infor Consulting Services in Asia Pacific, Infor Consulting Services in Egypt, Infor Consulting Services in Singapore, Infor Consulting Services in Thailand, Infor Consulting Services in Srilanka, Infor Consulting Services in Fiji, Infor Consulting Services in Cambodia, Infor Consulting Services in Malaysia, Infor Consulting Services in Wyoming, Infor Consulting Services in Japan, Infor Consulting Services in China, Infor Consulting Services in Europe, Infor Consulting Services in United Kingdom, Infor Consulting Services in Saudi Arabia, Infor Global Solutions, Infor MRP, Infor Cpq, Infor Pathway, Infor Sx.e, Infor India Pvt LTD, Infor WFM, Infor Products, Infor Company Logo, Infor OS, Infor EAM Logo, Infor Enterprise Software Suite, Infor Sign, Infor Service Management, Infor System 21 ERP, Infor Birst, USPS Infor, Infor Visual Manufacturing, Infor Gold Channel Partner, Esab Infor Software, Infor HQ, Infor Nexus, BPCS ERP, Infor CMMS, Infor EPM, New Infor Logo, Infor Delivery Partner, Supply Chain Management Software" />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="7 days" />
        <meta name="author" content="Kapil's Infor Services" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://www.kapiltech.com/services/infor" />
        
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>






      {/*Introduction video */}
      <section>
       
        <video 
             src="https://ik.imagekit.io/kqumni8l2/InforIntroVideoFinal.mp4?updatedAt=1737523527046"
            className="w-full h-full object-cover" 
            preload="metadata" 
            autoPlay 
            muted={false} // Set to false to enable audio
            controls
            playsInline
            style={{ width: "100%", height: "100%" }}
        >
            Your browser does not support the video tag.
        </video>
      </section  >
    
      {/* client logo scroll */}
      <div className='bg-gray-500'>
         <InforClient logos={clientLogos} />
     </div>
     
      
{/* 
<section className="bg-white p-4 md:p-8">
  <div className="flex flex-col items-center max-w-screen-lg mx-auto">
    <img
      src={InforAllianceImage}
      alt="Infor services LN M3 and Syteline"
      className="w-full h-auto mb-6 rounded-lg "
    />
    <div className="w-full">
    
    </div>
  </div>
</section> */}

{/* Whatsapp icon */}
      <section>
        < WhatsAppButton/>
      </section>



 {/* Contact Button */}
{/* <button
  onClick={(e) => {
    e.stopPropagation();
    setIsContactOpen(!isContactOpen);
  }}
  className="fixed bottom-16 right-6 w-20 h-20  cursor-pointer focus:outline-none z-50"
>
 
        
  <img src="https://ik.imagekit.io/7wqj9br0b/Infor/Robot-unscreen-unscreen.gif?updatedAt=1737000927753" alt="ChatBot"  className='h-24 w-24'/>
</button> */}

{/* Contact Popup */}
{/* {isContactOpen && (
  <div 
    className="fixed inset-0 flex justify-end items-start  sm:pt-20 p-2 z-50"
    onClick={(e) => {
      if (e.target === e.currentTarget) {
        setIsContactOpen(false);
      }
    }}
    style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}
  >
    <div 
      className="rounded-2xl w-full max-w-xs p-5 relative animate-fade-in-up shadow-lg border border-pink-100"
      style={{ 
        background: 'white',
      }}
    >
      <button
        onClick={() => setIsContactOpen(false)}
        className="absolute top-3 right-3 text-pink-400 hover:text-pink-600 transition-colors p-1 rounded-full hover:bg-pink-50"
      >
     
              <IoMdCloseCircle className="h-6 w-6" />
      </button>

      <div className="text-center mb-6">
        <h2 className="text-lg font-semibold  mb-1">Need Assistance?</h2>
        <p className="text-xs text-pink-400 font-medium">Your inquiries are just a message away—let's chat!</p>
      </div>
      
      <form onSubmit={handleSubmit} className="space-y-3">
        <input
          type="text"
          id="name"
          name="name"
          required
          className="w-full px-4 py-2 border border-pink-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-pink-300 text-sm placeholder:text-pink-300"
          placeholder="Enter Your Name *"
          value={formData.name}
          onChange={handleChange}
          style={{ 
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            transition: 'all 0.2s ease',
          }}
        />

        <input
          type="text"
          id="companyName"
          name="companyName"
          className="w-full px-4 py-2 border border-pink-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-pink-300 text-sm placeholder:text-pink-300"
          placeholder="Enter Your Company Name"
          value={formData.companyName}
          onChange={handleChange}
          style={{ 
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            transition: 'all 0.2s ease',
          }}
        />

        <input
          type="email"
          id="email"
          name="email"
          required
          className="w-full px-4 py-2 border border-pink-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-pink-300 text-sm placeholder:text-pink-300"
          placeholder="Enter Your Email Address *"
          value={formData.email}
          onChange={handleChange}
          style={{ 
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            transition: 'all 0.2s ease',
          }}
        />

        <input
          type="tel"
          id="phoneNumber"
          name="phoneNumber"
          className="w-full px-4 py-2 border border-pink-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-pink-300 text-sm placeholder:text-pink-300"
          placeholder="Enter Your Phone Number"
          value={formData.phoneNumber}
          onChange={handleChange}
          style={{ 
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            transition: 'all 0.2s ease',
          }}
        />

        <textarea
          id="message"
          name="message"
          required
          rows="2"
          className="w-full px-4 py-2 border border-pink-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-pink-300 text-sm placeholder:text-pink-300"
          placeholder="💭 How can we help you? *"
          value={formData.message}
          onChange={handleChange}
          style={{ 
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            transition: 'all 0.2s ease',
          }}
        />

        <button
          type="submit"
          className="w-full text-white font-medium py-2.5 px-4 rounded-xl transition-all duration-200 text-sm shadow-md hover:shadow-lg hover:-translate-y-0.5"
          style={{ 
            background: 'red',
          }}
        >
         Click Here
        </button>

        <p className="text-[10px] text-pink-400 text-center mt-2 font-medium">
          We'll get back to you within 24 hours! 🚀
        </p>
      </form>
    </div>
  </div>
  
  
)} */}
         
      {/* Services Image */}
<section className="py-10 bg-white">
  <div className="max-w-5xl mx-auto text-center px-4">
    <h2 className="text-3xl font-bold mb-6 text-gray-800">Kapil Tech Infor Services Portfolio</h2>
    <img 
      src="https://ik.imagekit.io/7wqj9br0b/Infor/Infor_Services_Offerings.png?updatedAt=1736999085606" 
      alt="Infor Consulting Services" 
      className="w-full h-auto max-w-4xl text-center m-auto "
    />
  </div>
</section>
    {/* Services in detail */}
      <section>
        <InforServices/>
      </section>




      {/* our services images  */}
      <section>
        <ServiceCards/>
       </section>
     
      <section>

        <PhotoCollage/>
      </section> 


      

      <section>
        <ContactForm/>
      </section>

      

       <section>
        <Faq />
      </section>
     

      <section>

      </section>
    </div>
  );
};

export default Infor;



